import {
    Caption,
    Label,
    useDeviceTypeContext,
    useStyles,
} from '@archipro-design/aria';
import * as S from './DetailedProductSpliter.style';

interface Props {
    category?: string;
    professionalTitle?: string;
    columns: number;
}

const getDiscoverProductsString = (
    category?: string,
    professionalTitle?: string,
) => {
    switch (true) {
        case !!category:
            return `Discover more products in the ${category} category`;
        case !!professionalTitle:
            return `Discover more products from ${professionalTitle}`;
        default:
            return 'Discover more products on ArchiPro.';
    }
};

const getCaption = (category?: string) => {
    switch (true) {
        case !!category:
            return `There are currently no more products available for online purchase in the selected category.`;
        default:
            return `There are currently no more products available for online purchase.`;
    }
};

const getExploreAdditionalString = (
    category?: string,
    professionalTitle?: string,
) => {
    switch (true) {
        case !!category:
            return `Explore additional products in this category.`;
        case !!professionalTitle:
            return `Explore additional products from ${professionalTitle}.`;
        default:
            return 'Explore additional products on ArchiPro and get in touch with the supplier.';
    }
};

const DetailedProductSpliter = ({
    category,
    professionalTitle,
    columns,
}: Props) => {
    const { css } = useStyles({ columns });
    const { mobile } = useDeviceTypeContext();

    return (
        <div className={css(S.MoreProductComing)}>
            <Label
                variant={mobile ? '02' : '01'}
                variables={{
                    letterSpacing: '0.01em',
                }}
            >
                {getDiscoverProductsString(category, professionalTitle)}
            </Label>
            <Caption variant={mobile ? '04' : '03'} className={css(S.Message)}>
                {getCaption(category)}
                <br />
                {getExploreAdditionalString(category, professionalTitle)}
            </Caption>
        </div>
    );
};

export default DetailedProductSpliter;
